<template>
  <div class="filters" :class="{ active: active, open: drawerOpen }">
    <h2>Filter By<span>{{ partners.length }} results</span></h2>

    <div class="filters-content">
      <div class="filter-group">
        <h3>Side</h3>
        <div class="filters-list">
          <button class="filter" @click="filterBySide('EAST')" :class="{ active: $parent.selectedSide.indexOf('EAST') > -1 }">EAST</button>
          <button class="filter" @click="filterBySide('WEST')" :class="{ active: $parent.selectedSide.indexOf('WEST') > -1 }">WEST</button>
        </div>
      </div>

      <div class="filter-group">
        <h3>Category</h3>
        <div class="filters-list">
          <button class="filter" @click="filterByEventType('Eat/Drink')" :class="{ active: selectedCategory.indexOf('Eat/Drink') > -1 }">Eat/Drink</button>
          <button class="filter" @click="filterByEventType('See/Learn')" :class="{ active: selectedCategory.indexOf('See/Learn') > -1 }">See/Learn</button>
          <button class="filter" @click="filterByEventType('Shop')" :class="{ active: selectedCategory.indexOf('Shop') > -1 }">Shop</button>
          <button class="filter" @click="filterByEventType('Other')" :class="{ active: selectedCategory.indexOf('Other') > -1 }">Other</button>
        </div>
      </div>
    </div>

    <button class="btn" v-on:click="closeDrawer">Close</button>
  </div>
</template>

<script>
export default {
  props: ["partners", "selectedCategory"],
  data() {
    return {
      active: false,
      activeTimeout: null,
      drawerOpen: false,
    }
  },
  methods: {
    filterUpdate() {
      this.$parent.filtersChanged();
    },
    filterBySide(by) {
      this.$parent.selectedSide = this.$parent.selectedSide === by ? '' : by;

      this.filterUpdate();
    },
    filterByEventType(by) {
      if (this.$parent.selectedCategory.indexOf(by) > -1) {
        this.$parent.selectedCategory.splice(this.$parent.selectedCategory.indexOf(by), 1);
      } else {
        this.$parent.selectedCategory.push(by);
      }

      this.filterUpdate();
    },
    openDrawer() {
      clearTimeout(this.activeTimeout);
      this.active = true;
      document.body.classList.add('stop-scroll');
      setTimeout(() => {
        this.drawerOpen = true;
      }, 50);
    },
    closeDrawer() {
      this.drawerOpen = false;
      document.body.classList.remove('stop-scroll');
      this.activeTimeout = setTimeout(() => {
        this.active = false;
      }, 500);
    },
  },
};
</script>

<style src="../css/Filters.less" scoped lang="less"></style>



// WEBPACK FOOTER //
// src/components/BPFilters.vue